import { configureStore } from '@reduxjs/toolkit';

import defaultMiddleware from './middleware';
import createReducer from './reducers';

export const createStore = (middleware: any, preloadedState: any) => {
  const rootReducer = createReducer();

  const store = configureStore({
    reducer: createReducer(),
    devTools: __DEV__,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      })
        .concat(middleware)
        .concat(defaultMiddleware),
  });

  // @ts-ignore
  if (__DEV__ && module.hot) {
    // @ts-ignore
    module.hot.accept('./reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

export type RootState = ReturnType<ReturnType<typeof createStore>['getState']>;
